import type { ReferentialInterventionType } from "./referential-intervention-types.type";
import type { UseReferentialOptions } from "@/entities/referential";
import type { Int } from "@/types";

import { useReferential, REFERENTIAL_NAMES } from "@/entities/referential";

export const useInterventionType = (
  options?: UseReferentialOptions<ReferentialInterventionType[]>
) => {
  const { data: interventionTypes = [], ...result } = useReferential<
    ReferentialInterventionType[]
  >(REFERENTIAL_NAMES.INTERVENTION_TYPES, options);

  const getSubTypes = (typeId?: Int) =>
    interventionTypes.find(({ id }) => id === typeId)?.subtypes ?? [];

  return {
    ...result,
    types: interventionTypes,
    subTypes: getSubTypes,
  };
};
